import React from 'react'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { titleize } from 'helpers/utils'

function WeightBadge({ weight }) {
  const getWeightColor = (weight) => {
    if (weight === 'low') {
      return 'text-primary'
    } else if (weight === 'med') {
      return 'text-warning'
    } else if (weight === 'high') {
      return 'text-danger'
    }
  }

  return (
    <Badge bg="light" className="bg-white border border-light">
      <FontAwesomeIcon
        className={`${getWeightColor(weight)} fa-xs`}
        icon={faCircle}
      />{' '}
      <span className="text-primary">{titleize(weight)}</span>
    </Badge>
  )
}

export default WeightBadge
